import React from 'react';
import MasterDataView from './MasterDataView';
import { MasterDataContextProvider } from '../../context';

const MasterData = () => {
    return (
        <MasterDataContextProvider>
            <MasterDataView />
        </MasterDataContextProvider>
    );
};

export default MasterData;
